<template>
  <div
    class="relative flex items-center justify-center min-h-screen px-4 py-12 overflow-hidden isolate bg-gray-50"
  >
    <!-- Decorative themed background -->
    <div
      class="absolute inset-0 -z-10 bg-gradient-to-br from-primary/5 via-gray-50 to-primary/10"
    ></div>
    <div
      class="absolute rounded-full -top-24 -right-24 -z-10 w-80 h-80 bg-primary/10 blur-3xl"
    ></div>
    <div
      class="absolute rounded-full -bottom-24 -left-24 -z-10 w-80 h-80 bg-primary/10 blur-3xl"
    ></div>

    <div class="w-full max-w-md">
      <!-- Brand header -->
      <div class="mb-8 text-center">
        <div
          class="inline-flex items-center justify-center w-16 h-16 mb-4 bg-white shadow-sm rounded-2xl ring-1 ring-gray-100"
        >
          <ApplicationLogo class="w-10 h-10 text-primary" />
        </div>
        <h1 class="text-xl font-bold text-gray-900 font-roboto-slab">
          {{ apps.namaapps || "Panel Admin" }}
        </h1>
        <p class="mt-1 text-sm text-gray-500">
          Masuk untuk mengelola konten dan pengaturan.
        </p>
      </div>

      <!-- Card -->
      <div
        class="p-6 bg-white border border-gray-100 shadow-xl sm:p-8 rounded-2xl"
      >
        <!-- Status message -->
        <div
          v-if="status"
          class="px-4 py-3 mb-4 text-sm font-medium text-green-700 rounded-lg bg-green-50"
        >
          {{ status }}
        </div>

        <form @submit.prevent="submit" class="space-y-5">
          <!-- Username -->
          <div>
            <label
              for="username"
              class="block mb-1.5 text-sm font-medium text-gray-700"
            >
              Username
            </label>
            <div class="relative">
              <span
                class="absolute inset-y-0 left-0 flex items-center pl-3.5 text-gray-400 pointer-events-none"
              >
                <i class="fa-solid fa-user"></i>
              </span>
              <input
                id="username"
                v-model="form.username"
                type="text"
                autocomplete="username"
                placeholder="Masukkan username..."
                class="block w-full py-2.5 pl-10 pr-3 text-sm text-gray-900 bg-white border border-gray-300 shadow-sm rounded-lg placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary hover:border-gray-400 transition-colors"
              />
            </div>
            <InputError :message="form.errors.username" class="mt-2" />
          </div>

          <!-- Password -->
          <div>
            <label
              for="password"
              class="block mb-1.5 text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <div class="relative">
              <span
                class="absolute inset-y-0 left-0 flex items-center pl-3.5 text-gray-400 pointer-events-none"
              >
                <i class="fa-solid fa-lock"></i>
              </span>
              <input
                id="password"
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                autocomplete="current-password"
                placeholder="Masukkan password..."
                class="block w-full py-2.5 pl-10 pr-10 text-sm text-gray-900 bg-white border border-gray-300 shadow-sm rounded-lg placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary hover:border-gray-400 transition-colors"
              />
              <button
                type="button"
                @click="showPassword = !showPassword"
                class="absolute inset-y-0 right-0 flex items-center pr-3.5 text-gray-400 transition-colors hover:text-primary focus:outline-none"
                :aria-label="
                  showPassword ? 'Sembunyikan password' : 'Tampilkan password'
                "
              >
                <i
                  :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                  class="fa-solid"
                ></i>
              </button>
            </div>
            <InputError :message="form.errors.password" class="mt-2" />
          </div>

          <!-- Submit -->
          <button
            type="submit"
            :disabled="form.processing"
            class="flex items-center justify-center w-full gap-2 px-5 py-2.5 text-sm font-semibold text-white transition-all duration-200 rounded-lg shadow-sm bg-primary hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <i
              :class="
                form.processing
                  ? 'fa-spinner fa-spin'
                  : 'fa-right-to-bracket'
              "
              class="fa-solid"
            ></i>
            {{ form.processing ? "Memproses..." : "Masuk" }}
          </button>
        </form>
      </div>

      <!-- Back to website -->
      <p class="mt-6 text-sm text-center text-gray-500">
        <a
          :href="apps.url || '/'"
          class="inline-flex items-center gap-1.5 font-medium transition-colors hover:text-primary"
        >
          <i class="fa-solid fa-arrow-left"></i>
          Kembali ke website
        </a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useForm, usePage } from "@inertiajs/vue3";
import ApplicationLogo from "@/Components/ApplicationLogo.vue";
import InputError from "@/Components/InputError.vue";

defineProps({
  status: String,
});

const page = usePage();
const apps = computed(() => page.props.apps || {});

const form = useForm({
  username: "",
  password: "",
  remember: null,
});
const showPassword = ref(false);

const submit = () => {
  form.post(route("adminpanel"), {
    onFinish: () => form.reset("password"),
  });
};
</script>
